<template>
  <div>
    <v-list nav dense v-if='projectsMenu.length > 0'>
      <v-subheader :class='headerClass'>Project Modules</v-subheader>
      <v-list-item-group color='primary'>
        <v-list-item v-for='(m, pIndex) in projectsMenu' :key='pIndex' :to="{ name: m.route }">
          <v-list-item-icon>
            <v-icon v-text='m.icon' :color='m.color'></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text='m.title'></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  
    <v-list nav dense>
      <v-subheader :class='headerClass'>Main Modules</v-subheader>
      <v-list-item-group color='primary'>
        <v-list-item v-for='(m, mIndex) in menu' :key='mIndex' :to="{ name: m.route }">
          <v-list-item-icon>
            <v-icon v-text='m.icon' :color='m.color'></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text='m.title'></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import _ from 'lodash';
import permsService from '@/services/perms';
import { mapState } from 'vuex';

export default {
  name: 'app-menu',
  data: () => ({
    headerClass: 'overline font-weight-light'
  }),
  computed: {
    projectsMenu () {
      let menu = []
      let giveAccess = false
      const divs = _.orderBy(this.$store.state.misc.divisions, 'order')

      for (let i = 0; i < divs.length; i++) {
        giveAccess = false
        let tmpURL = {
          title: divs[i].division,
          icon: divs[i].icon,
          color: divs[i].icon_color
        }

        switch (divs[i].division_type) {
           case 'C':
            tmpURL.route = 'ConstructionDashboard'
            giveAccess = permsService.hasAccess('constructionprojects')
            break
          case 'W':
            tmpURL.route = 'SoftwareDashboard'
            giveAccess = permsService.hasAccess('softwareprojects')
            break
          case 'S':
            tmpURL.route = 'SnowDashboard'
            giveAccess = permsService.hasAccess('snowprojects')
            break
          case 'L':
            tmpURL.route = 'LawnDashboard'
            giveAccess = permsService.hasAccess('lawnprojects')
            break
          case 'I':
            tmpURL.route = 'IrrigationDashboard'
            giveAccess = permsService.hasAccess('irrigationprojects')
            break
          default:
            giveAccess = permsService.hasAccess('projects')
            tmpURL.route = 'SnowDashboard'
            break
        }
        if (giveAccess) {
          menu.push(tmpURL)
        }
      }
      const staging = {
        title: "Staging",
        icon: 'mdi-view-column-outline',
        color: 'red',
        route: 'StagingDashboard'
      }
      menu.push(staging);
      return menu
    },
    ...mapState({
      estimates: state => state.icons.modules.estimates,
      schedule: state => state.icons.modules.schedule,
    }),
    menu () {
      let menu = []

      // There might be a faster/better way to do this
      if (permsService.hasAccess('schedule')) {
        menu.push({ title: this.schedule.title, icon: this.schedule.icon, color: this.schedule.color, route: 'ScheduleDashboard' })
      }
      if (permsService.hasAccess('inquiries')) {
        menu.push({ title: 'Inquiries', icon: this.$store.state.icons.modules.inquiries.icon, color: this.$store.state.icons.modules.inquiries.color, route: 'InquiriesDashboard' })
      }
      if (permsService.hasAccess('estimates')) {
        menu.push({ title: 'Estimates', icon: this.$store.state.icons.modules.estimates.icon, color: this.$store.state.icons.modules.estimates.color, route: 'EstimatesDashboard' })
      }
      if (permsService.hasAccess('clients')) {
        menu.push({ title: 'Clients', icon: this.$store.state.icons.modules.clients.icon, color: this.$store.state.icons.modules.clients.color, route: 'ClientsDashboard' })
       }
      if (permsService.hasAccess('fieldcrews')) {
        menu.push({ title: this.$store.state.icons.modules.fieldcrews.title, icon: this.$store.state.icons.modules.fieldcrews.icon, color: this.$store.state.icons.modules.fieldcrews.color, route: 'FieldcrewsDashboard' })
      }
      if (permsService.hasAccess('accounting')) {
        menu.push({ title: 'Accounting', icon: this.$store.state.icons.modules.accounting.icon, color: this.$store.state.icons.modules.accounting.color, route: 'AccountingDashboard' })
      }
      if (permsService.hasAccess('timesheets')) {
        menu.push({
          title: this.$store.state.icons.modules.timesheets.title,
          icon: this.$store.state.icons.modules.timesheets.icon,
          color: this.$store.state.icons.modules.timesheets.color, route: 'TimesheetsDashboard'
        })
      }
      if (permsService.hasAccess('workorders')) {
        menu.push({ title: 'Work Orders', icon: this.$store.state.icons.modules.workorders.icon, color: this.$store.state.icons.modules.workorders.color, route: 'WOsDashboard' })
      }
      if (permsService.hasAccess('assets')) {
        menu.push({ title: 'Assets', icon: this.$store.state.icons.modules.assets.icon, color: this.$store.state.icons.modules.assets.color, route: 'AssetsDashboard' })
      }
      if (permsService.hasAccess('notices')) {
        menu.push({ title: 'Notices', icon: this.$store.state.icons.modules.notices.icon, color: this.$store.state.icons.modules.notices.color, route: 'NoticesDashboard' })
      }
      if (permsService.hasAccess('staffing')) {
        menu.push({ title: this.$store.state.icons.modules.staffing.title, icon: this.$store.state.icons.modules.staffing.icon, color: this.$store.state.icons.modules.staffing.color, route: 'StaffingDashboard' })
      }
      if (permsService.hasAccess('payroll')) {
        menu.push({ title: this.$store.state.icons.modules.payroll.title, icon: this.$store.state.icons.modules.payroll.icon, color: this.$store.state.icons.modules.payroll.color, route: 'PayrollDashboard' })
      }
      if (permsService.hasAccess('management')) {
        menu.push({
          title: this.$store.state.icons.modules.management.title,
          icon: this.$store.state.icons.modules.management.icon,
          color: this.$store.state.icons.modules.management.color,
          route: 'ManagementDashboard'
        })
      }
      if (permsService.hasAccess('settings')) {
        menu.push({
          title: 'Settings',
          icon: this.$store.state.icons.modules.settings.icon,
          color: this.$store.state.icons.modules.settings.color,
          route: 'SettingsDashboard'
        })
      }
      return menu
    }
  }
}
</script>
